import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { AuthService } from 'src/shared/services/REST-API/rest.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { GlobalVarService } from 'src/shared/services/global-var.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  host: { '(document:click)': 'onClick($event)', }
})

export class HeaderComponent implements OnInit {
  @ViewChild('navBar') nav;
  userData;
  public innerWidth: any;
  url = 'https://apis.google.com/js/platform.js';
  avatar: any;

  constructor(private authService: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private globalVar: GlobalVarService,
    private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.authService.user.subscribe((userData) => {
      this.userData = userData
      this.subAvatar();
      if (userData) {
        this.authService.getAvatar().subscribe((data) => {
          if (JSON.stringify(data) === '{}') { return }
          var uints = new Uint8Array(data.binary.data);
          var image = btoa(String.fromCharCode.apply(null, uints));
          const avatar = this.sanitizer.bypassSecurityTrustUrl('data:image/jpg;base64,' + image);
          this.globalVar.avatarBinary.next(avatar)

          return this.subAvatar();
        })
      }
    });
    this.loadScript()
  }

  public loadScript() {
    let node = document.createElement('script');
    node.src = this.url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  subAvatar() {
    this.globalVar.avatarBinary.subscribe((data) => {
      this.avatar = data;
    })
  }

  onLogOut() {
    this.signOut()
    this.authService.logOut().subscribe(() => {
      this.authService.user.next(null)
      localStorage.removeItem('loginDeatils')
      this.globalVar.avatarBinary.next(null)
      this.toastr.success("Successfully Logged Out");
      this.router.navigate([''])
    })
  }
  signOut() {
    gapi.load('auth2', function () {
      gapi.auth2.init({
        client_id: '178371403416-m4cel4952k3jdfc99sn9pu7vohq03gc5.apps.googleusercontent.com'
      }).then(function (authInstance) {
        var auth2 = gapi.auth2.getAuthInstance();
        auth2.signOut().then(function () {
        });

      });
    });

  }

  onClickUserIcon() {
    const showUserDetails = this.globalVar.showDropDown.getValue()
    this.globalVar.showDropDown.next(!showUserDetails);
  }

  onClick(event) {
    if (event.target.className !== "userImage" && event.target.className !== "userImage ng-star-inserted" && event.target.className !== "ng-star-inserted") {
      this.globalVar.showDropDown.next(false);
    }
    if (this.innerWidth <= 600 && this.nav.nativeElement.checked && event.target.className !== "bubble") {
      this.nav.nativeElement.click()
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }
}
